module.exports = __webpack_public_path__ + "img/jumelle.65237404.png";